import { gql } from "@apollo/client";

export const deleteKeywordGroup = gql`
  mutation DeleteKeywordGroup($id: ID!) {
    deleteKeywordGroup(id: $id)
  }
`;
